<template>
  <div aria-hidden="true">
    <button @click.stop="clickBot" class="senas-video" aria-label="Abrir video en lenguaje de señas">
      <div class="acces-icon back-red hvr-grow">
        <v-icon class="always-white">fa fa-sign-language</v-icon>
      </div>
      <div class="acces-bot-name back-red animated fadeIn">
        <p class="always-white">Ver video en LSC</p>
      </div>
    </button>
    <v-dialog v-if="modalOne" v-model="modalOne" width="800" role="dialog" aria-label="Video saludos en lengua de señas">
      <v-card class="pt-3 pb-2 align-center">

        <video-app v-if="youtubeEmbed" :vidTittle="vidTittle" :videoSize="videoSize" :youtubeEmbed="youtubeEmbed"></video-app>
        <video-app v-if="videoEmbed" :vidTittle="vidTittle" :videoSize="videoSize" :videoEmbed="videoEmbed"></video-app>

        <ui-button class="mt-2 mb-2" secondary :content="'Ocultar video en LSC'" :aria="'Ocultar video en LSC'" @click.native="modalOne = false"></ui-button>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    youtubeEmbed: {
      type: String,      
      required: false
    },
    videoEmbed: {
      type: String,      
      required: false
    },
    videoSize: {
      Type: Number,
      required: false
    },
    vidTittle: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      modalOne: false
    };
  },
  methods: {
    clickBot() {
      this.modalOne = true;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// Accesvideo.vue?3fd21fd8